import { useFormState } from 'informed';

import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import { CommonProps } from '../../layout/LoanForm';
import { AgreementsOutput } from '../../hooks/useAgreements';
import { StepNav, AgreementsCheckboxesSection } from '../index';

interface UniqueProps {
  open: boolean;
  handleClose: () => void;
  onAccept: () => void;
}

const AgreementsModal = ({
  t,
  open,
  agreements,
  requiredAgreementsIds,
  onAccept,
  handleClose,
}: CommonProps & AgreementsOutput & UniqueProps) => {
  const { valid } = useFormState();

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={(theme) => ({
          position: 'absolute',
          overflowY: 'scroll',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: 815,
          maxHeight: '90vh',
          width: 736,
          maxWidth: '100vw',
          bgcolor: 'var(--modal-bg-color, #fff)',
          boxShadow: 24,
          color: '#3E3E3E',
          borderRadius: 6,
          p: '1rem 2rem',
          // border: '2px solid #000',

          [theme.breakpoints.up('sm')]: {
            maxWidth: 736,
            padding: '5.6rem 8rem',
          },

          // [theme.breakpoints.up("lg")]: {
          //   maxHeight: "65rem",
          //   width: "118rem",
          //   height: "65rem",
          //   margin: "auto",
          //   borderRadius: "1rem",
          //   p: 0,
          //   overflow: "hidden",
          // },
        })}
      >
        <Typography fontSize={20} fontWeight={600}>
          {t.basicStep.agreementInfo}
        </Typography>

        <AgreementsCheckboxesSection
          t={t}
          agreements={agreements}
          requiredAgreementsIds={requiredAgreementsIds}
        />

        <StepNav
          sx={(theme) => ({
            justifyContent: 'flex-end',
            margin: '3rem 0 0 auto',
            [theme.breakpoints.up('sm')]: {
              margin: '4rem 0 0 auto',
            },
          })}
          t={t}
          hideBack
          disabled={!valid}
          onNext={() => onAccept()}
          customNextText={t.common.next}
        />
      </Box>
    </Modal>
  );
};

export default AgreementsModal;
